import ImageOptions from "%/dynamic-component-editor/bundles/image-options";
import SingleImage from "%/dynamic-component-editor/options/single-image";
import {
  StandardImageElementMixin,
} from "%/dynamic-component-editor/standard-elements/image-element/standard-image-element-mixin";
import { OptionMediaResolverMixin } from "%/dynamic-component-editor/mixins/option-media-resolver-mixin";

export const SingleImageElementMixin = {
  mixins: [StandardImageElementMixin, OptionMediaResolverMixin],
  optionBundles: [
    ImageOptions,
  ],
  computed: {
    fallbackImageSrc() {
      return "";
    },
    // Stored either as a media_id (resolved to a fresh URL at render) or a
    // legacy URL (used directly).
    imageMediaUnresolvable() {
      return this.isOptionMediaUnresolvable(this.getOptionValue(SingleImage));
    },
    imageSrc() {
      return this.resolveOptionMedia(this.getOptionValue(SingleImage));
    },
  },
};
